import { render, staticRenderFns } from "./AiAssistantHistoryComponent.vue?vue&type=template&id=3b888b0c&scoped=true"
import script from "./AiAssistantHistoryComponent.vue?vue&type=script&lang=js"
export * from "./AiAssistantHistoryComponent.vue?vue&type=script&lang=js"
import style0 from "./ai-history.css?vue&type=style&index=0&id=3b888b0c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b888b0c",
  null
  
)

export default component.exports